import React,{useEffect} from "react";
import "./ReturnPolicy.css";
import HomeHeader from "../../components/header/HomeHeader";
import CommonFooter from "../../components/footer/CommonFooter";
import Breadcrumb from "../../components/breadcrumb";

const ReturnPolicy = () => {  
  useEffect(()=> {
    window.scrollTo({
      top:0,
      behavior:'smooth'
    })
  },[]);
  return (
    <div className="return-policy">
      {/* <HomeHeader /> */}
      <Breadcrumb
        items={[
          { 
            label: "Home",
            path: "/",
          },
          {
            label: "Return Policy",
            isActive: true,
          },
        ]}
      />

      <main className="return-policy__main">
        <div className="return-policy__container">
          <div className="return-policy__content">
            <p className="return-policy__intro">
              At Yug Mantra, we want you to be completely satisfied with your blouse purchase. If you're not happy with your blouse order, we're here to help with our customer-friendly return policy.
            </p>

            <div className="return-policy__section">
              <h2 className="return-policy__section-title">Return Window</h2>
              <p>You have 7 days from the date of delivery to initiate a return for most blouses. Custom-made or personalized blouses may have different return windows based on their nature.</p>
            </div>

            <div className="return-policy__section">
              <h2 className="return-policy__section-title">Eligible Blouses for Return</h2>
              <ul className="return-policy__list">
                <li>Blouses in original condition with all tags attached</li>
                <li>Unused and unwashed blouses</li>
                <li>Blouses in original packaging</li>
                <li>Blouses with manufacturing defects</li>
                <li>Standard size blouses (non-customized)</li>
              </ul>
            </div>

            <div className="return-policy__section">
              <h2 className="return-policy__section-title">Non-Returnable Blouses</h2>
              <ul className="return-policy__list">
                <li>Personalized or custom-made blouses</li>
                <li>Blouses marked as "Final Sale"</li>
                <li>Blouses that have been worn, washed, or altered</li>
                <li>Blouses without original tags or packaging</li>
                <li>Blouses with embroidery or heavy work that has been damaged</li>
              </ul>
            </div>

            <div className="return-policy__section">
              <h2 className="return-policy__section-title">How to Return Blouses</h2>
              <ol className="return-policy__ordered-list">
                <li>Log into your account and go to "My Orders"</li>
                <li>Select the blouse order you want to return</li>
                <li>Choose the blouses you want to return and provide a reason</li>
                <li>Print the return label or use our pickup service</li>
                <li>Pack the blouses securely with all original packaging</li>
                <li>Ship the package or schedule a pickup</li>
              </ol>
            </div>

            <div className="return-policy__section">
              <h2 className="return-policy__section-title">Refund Process</h2>
              <ul className="return-policy__list">
                <li>Refunds will be processed within 5-7 business days after we receive your blouse return</li>
                <li>Refunds will be issued to the original payment method</li>
                <li>Shipping costs are non-refundable unless the blouse was defective</li>
                <li>You will receive an email confirmation once the refund is processed</li>
              </ul>
            </div>

            <div className="return-policy__section">
              <h2 className="return-policy__section-title">Blouse Exchange Policy</h2>
              <p>We offer exchanges for different sizes or colors of the same blouse design, subject to availability. Exchanges follow the same timeline and conditions as returns.</p>
            </div>

            <div className="return-policy__section">
              <h2 className="return-policy__section-title">Contact Information</h2>
              <div className="return-policy__contact">
                <p><strong>Phone:</strong> +91-7490026756</p>
                <p><strong>Email:</strong> info@siddharthfashion.com</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <CommonFooter />
    </div>
  );
};

export default ReturnPolicy;